import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconTimeSvg } from "./IconTimeSvg.mjs";
const IconTime = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconTimeSvg, ...svgProps }) });
export {
  IconTime
};
